import { render, staticRenderFns } from "./OilTrackerByCarList.vue?vue&type=template&id=48fa136b&scoped=true"
import script from "./OilTrackerByCarList.vue?vue&type=script&lang=js"
export * from "./OilTrackerByCarList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fa136b",
  null
  
)

export default component.exports